import { useState } from "react";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";

import Header from "./components/Header/Header";
import AppRoutes from "./Routes";
import SuccessSnackbar from "./widgets/Snackbar/SuccessSnackbar";
import tokenUtils from "./utils/tokenUtils";
import routes from "./constants/routes";

const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [logoutSnackbar, setLogoutSnackbar] = useState({
    open: false,
    message: "",
  });

  const isLoginPage = location.pathname === routes.login.root;

  const handleLogout = () => {
    tokenUtils.deleteToken();
    setLogoutSnackbar({
      open: true,
      message: "You have been logged out successfully.",
    });

    navigate(routes.login.root, { replace: true });
  };

  return (
    <>
      <Header showLogout={!isLoginPage} onLogout={handleLogout} />
      <AppRoutes />

      <SuccessSnackbar
        open={logoutSnackbar.open}
        message={logoutSnackbar.message}
        onClose={() => setLogoutSnackbar({ open: false, message: "" })}
      />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
